'use client'

import { BlockHeading } from '@/components/BlockHeading'
import { FormBuilderForm } from '@/components/FormBuilderForm'
import { Tagline } from '@/components/pro-blocks/landing-page/tagline'
import { PayloadRichText } from '@/components/PayloadRichText'
import { AspectRatio } from '@/components/ui/aspect-ratio'
import type { Media, SplitImageContactBlock } from "@/payload-types";
import { resolveMediaSrc } from '@/utilities/getMediaUrl'
import { hasRichText } from "@/utilities/hasRichText";

export function SplitImageContactBlock(props: SplitImageContactBlock) {
  const hasTagline = Boolean(props.tagline?.trim())
  const hasHeading = Boolean(props.heading?.trim())
  const hasDescription = hasRichText(props.description)
  const headingId = hasHeading ? 'contact-heading' : undefined

  const imageUrl = resolveMediaSrc(props.image) || null
  const imageOnRight = props.imagePosition === 'right'
  const formDoc = props.form && typeof props.form !== 'string' ? props.form : null

  if (!formDoc) return null

  return (
    <section id="contact" aria-labelledby={headingId} className="bg-background">
      <div className="container mx-auto px-6">
        <div className="grid items-start gap-10 lg:grid-cols-2 lg:gap-16">
          <div className={imageOnRight ? 'order-2 lg:order-2' : 'order-2 lg:order-1'}>
            {imageUrl ? (
              <AspectRatio className="relative" ratio={1}>
                <img
                  alt={props.heading || props.tagline || 'Contact section image'}
                  className="absolute inset-0 size-full object-cover"
                  src={imageUrl}
                />
              </AspectRatio>
            ) : null}
          </div>

          <div className={imageOnRight ? 'order-1 lg:order-1' : 'order-1 lg:order-2'}>
            <div className="section-title-gap-lg mx-auto flex max-w-xl flex-col items-center text-center lg:mx-0 lg:items-start lg:text-left">
              {hasTagline ? <Tagline>{props.tagline}</Tagline> : null}
              {hasHeading ? (
                <BlockHeading className="text-foreground" headingStyle={props.headingStyle} id={headingId}>
                  {props.heading}
                </BlockHeading>
              ) : null}
              {hasDescription ? (
                <div className="text-muted-foreground [&_p]:m-0 [&_p+p]:mt-2">
                  <PayloadRichText data={props.description} />
                </div>
              ) : null}
            </div>

            <FormBuilderForm className="mt-8 flex w-full flex-col" form={formDoc} idPrefix="contact" />
          </div>
        </div>
      </div>
    </section>
  )
}
